import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  status: null,
  message: null,
  data: null,
  currentSector: null,  
  error: null         
};

const sectorSummaryReducer = createReducer(initialState, {
  SECTORS_REQ: (state, action) => {
    state.loading = true;
    state.status = "loading";
    state.currentSector = action.payload?.sectorName;
    state.error = null;
  },
  SECTORS_FETCH_SUC: (state, action) => {
    console.log("Reducer hit - SECTORS_FETCH_SUC", action.payload);
   const payload = action.payload;
    state.loading = false;
    state.status = payload.status;
    state.message = payload.message;
    state.data = {
      ...payload.data,
      lastUpdated: new Date().toISOString() 
    };
    state.error = null;
  },
  SECTORS_ERROR: (state, action) => {
    state.loading = false;
    state.status = "error";
    state.message = action.payload?.message || "Failed to fetch sector summary";
    state.data = null;
    state.error = action.payload?.error || "Unknown error";
  },
  FETCH_SECTOR_SUMMARY: (state, action) => {
    state.loading = true;
    state.status = "fetching";
    state.currentSector = action.payload?.sectorName;
  },
  FETCH_SECTOR_SUMMARY_SUCCESS: (state, action) => {
    state.loading = false;
    state.status = "success";
    state.data = action.payload.data;
    state.message = action.payload.message;
  },
  FETCH_SECTOR_SUMMARY_FAILURE: (state, action) => {
    state.loading = false;
    state.status = "failure";
    state.error = action.payload.error;
    state.message = action.payload.message;
  }
});

export default sectorSummaryReducer;